import { j as o } from "../../jsx-runtime-ClSzPYp4.js";
import a from "../BaseIcon.mjs";
const r = (s) => /* @__PURE__ */ o.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "HourGlass",
  ...s,
  children: /* @__PURE__ */ o.jsx("path", {
    d: "M19,6.36V1H5v5.36C5,8.61,6.4,10.75,8.5,12C6.4,13.53,5,16.35,5,18.6V23h14v-4.4c0-2.25-1.4-5.07-3.5-6.6   C17.6,10.75,19,8.61,19,6.36z M17,19v2H7v-2H17z M12,11.48c-2.99-0.65-5-3.36-5-4.82c0-1.46,0-1.65,0-1.65h9.96c0,0,0,0.17,0,1.65   C16.96,8.15,14.98,10.88,12,11.48z"
  })
}), v = (s) => /* @__PURE__ */ o.jsx(a, {
  IconSvg: r,
  ...s
});
export {
  v as default
};
